import Slider from "@/Components/Slider/indexSlider";
import BeneficiosCliente from "@/Components/benefits/BeneficiosCliente";
import Ig from "@/Components/instagram/ig";
import Benefits from "@/Components/benefits/benefits";
import PopupModal from "@/Components/PopupModal";
import { ReactNode } from "react";
import LayoutPrincipal from "@/Layout/principal";
import {
    ICarouselPrincipal,
    Instagram,
    ProductCategory,
    ProductosIndex,
    SeccionSlider,
} from "@/types/app";
import { PattyAlert } from "@/utils/global";
import CategoriaNavegacion from "@/Components/index/categoria-navegacion";
import ProductosDestacados from "@/Components/index/producto-destacado";

interface PopupData {
    id: number;
    titulo: string;
    descripcion: string | null;
    imagen: string | null;
    link_boton: string | null;
    texto_boton: string | null;
    mostrar_solo_una_vez: boolean;
    delay_segundos: number;
    posicion: 'center' | 'top' | 'bottom';
}

import ScrollReveal from "@/Components/ScrollReveal";

const Index = ({
    carouselPrincipal,
    error,
    instagram,
    categorias,
    agregadosRecientemente,
    masVendidos,
    canjeables,
    destacados,
    popups,
}: {
    carouselPrincipal: ICarouselPrincipal[];
    instagram: Instagram[];
    categorias: SeccionSlider[];
    agregadosRecientemente: ProductosIndex[];
    masVendidos: ProductosIndex[];
    canjeables: ProductosIndex[];
    destacados: ProductCategory[];
    popups: PopupData[];
    error: string | null;
}) => {
    if (error) {
        PattyAlert({ title: "Error", message: error, icon: "error" });
    }

    return (
        <div className="overflow-hidden">
            <PopupModal popups={popups} />

            {/* El Hero Banner inicial debe cargar de inmediato sin delay para no afectar LCP */}
            <Slider data={carouselPrincipal} />

            {/* A partir de aquí todo se revela al hacer scroll */}
            <ScrollReveal yOffset={60} duration={0.8} once={true}>
                <CategoriaNavegacion data={categorias} />
            </ScrollReveal>

            <ProductosDestacados
                AgregadosRecientemente={agregadosRecientemente}
                masVendidos={masVendidos}
                canjeables={canjeables}
                destacados={destacados}
            />

            <ScrollReveal yOffset={60} duration={0.8} once={true}>
                <BeneficiosCliente promocionesSecundarias={carouselPrincipal.filter((item) => item.nro_carousel === 2 || item.nro_carousel === 3)} />
            </ScrollReveal>

            <ScrollReveal yOffset={60} duration={0.8} once={true}>
                <Benefits />
            </ScrollReveal>

            <ScrollReveal yOffset={60} duration={0.8} once={true}>
                <Ig data={instagram} />
            </ScrollReveal>
        </div>
    );
};
Index.layout = (page: ReactNode) => <LayoutPrincipal children={page} />;

export default Index;
